'use client'

import React from 'react'

type Props = {
    legA: number
    legB: number
    hypotenuseC: number
}

const WIDTH = 340
const HEIGHT = 220

export default function RightTriangleChart({ legA, legB, hypotenuseC }: Props) {
    const a = Math.max(legA, 0.0001)
    const b = Math.max(legB, 0.0001)
    const scale = 130 / Math.max(a, b)
    const as = a * scale
    const bs = b * scale

    const Cx = 70, Cy = 170
    const Bx = Cx + as, By = Cy
    const Ax = Cx, Ay = Cy - bs

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <polygon points={`${Ax},${Ay} ${Bx},${By} ${Cx},${Cy}`} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            {/* right-angle marker */}
            <polyline points={`${Cx},${Cy - 14} ${Cx + 14},${Cy - 14} ${Cx + 14},${Cy}`} fill="none" stroke="#2563eb" strokeWidth={1.5} />
            <text x={(Bx + Cx) / 2} y={Cy + 20} fontSize={12} textAnchor="middle" fill="#374151">a = {legA.toFixed(2)}</text>
            <text x={Cx - 22} y={(Ay + Cy) / 2} fontSize={12} textAnchor="middle" fill="#374151">b = {legB.toFixed(2)}</text>
            <text x={(Ax + Bx) / 2 + 24} y={(Ay + By) / 2 - 4} fontSize={12} textAnchor="middle" fill="#374151">c = {hypotenuseC.toFixed(2)}</text>
        </svg>
    )
}
